// =============================================================================
// Repository: SpaceMembers — invite external members to a space via edge fn
// =============================================================================

import { supabase } from '@/integrations/supabase/client';
import type { PermissionLevel } from './permissionRepository';

export interface InviteToSpaceResult {
  success: boolean;
  code?: string;
  error?: string;
}

export async function inviteMemberToSpaceViaEdgeFunction(
  orgId: string,
  email: string,
  spaceId: string,
  spacePermission: PermissionLevel,
): Promise<InviteToSpaceResult> {
  const { data, error } = await supabase.functions.invoke('invite-member', {
    body: {
      org_id: orgId,
      email,
      role: 'member',
      space_id: spaceId,
      space_permission: spacePermission,
    },
  });

  if (error) throw error;
  return data as InviteToSpaceResult;
}
